module.exports = __webpack_public_path__ + "static/img/03.b4a590c4.png";